module.exports = __webpack_public_path__ + "media/images/greennote 10-e44d1ea67d3331fc762025da46d62bce.svg";